import React, { useMemo } from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import { pluralizeToString } from 'lib/string/pluralize'

interface Props {
  duration: number;
  itinerary: App.CruiseItineraryItem[];
}

export function HeroCruiseItinerary({ duration, itinerary }: Props) {
  const cities = useMemo(() => {
    return itinerary?.map((event) => {
      const { port } = event
      if (!port) return
      return port.city || port.name.split(',')[0]
    }).filter((city) => city && city.length > 1)
  }, [itinerary])

  const countries = useMemo(() => {
    return itinerary?.map((itineraryItem) => {
      const { port } = itineraryItem
      if (!port) return
      return port.countryCode
    }).filter(country => country?.length)
  }, [itinerary])

  const placesCount = [...new Set(cities)].length
  const countriesCount = [...new Set(countries)].length

  return (
    <BodyText variant="medium" colour="neutral-two">
      <Group direction="horizontal">
        <div>{pluralizeToString('night', duration)}</div>
        {!!placesCount && <div>&nbsp;· {pluralizeToString('port', placesCount)}</div>}
        {!!countriesCount && <div>&nbsp;· {pluralizeToString('country', countriesCount)}</div>}
      </Group>
    </BodyText>
  )
}
